import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AccountTrainingService } from 'src/app/account-training.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { WizardService } from 'src/app/wizard/wizard.service';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
@Component({
  selector: 'app-school-instructor-referral',
  templateUrl: './school-instructor-referral.component.html',
  styleUrls: ['./school-instructor-referral.component.less']
})
export class SchoolInstructorReferralComponent implements OnInit, OnDestroy {

  public faMagnifyingGlass = faMagnifyingGlass;

  @Input()
  public School: string;

  @Input()
  public parentGroup: UntypedFormGroup;

  public Instructors$: Observable<any>;

  public Instructor: any = null;

  public InstructorName: UntypedFormControl;

  public group: UntypedFormGroup

  constructor(
    private service: AccountTrainingService,
    private wizard: WizardService
  ) {
  }

  public ngOnInit(): void {
    if (this.School) {
      this.Instructors$ = Observable.create(observer => {
        observer.next(this.InstructorName.value);
      }).pipe(mergeMap((query: string) => this.service.Instructors(this.School, query)));
    }

    let ind_full_name_cp = null;

    if (this.wizard.Individual.cst_src_key === '7245e0f3-94c5-4b8d-9b42-179f84516aa9') {
      if (this.wizard.Individual.cst_src_referral_member_first_name_ext && this.wizard.Individual.cst_src_referral_member_last_name_ext) {
        this.Instructor = {
          cst_recno: this.wizard.Individual.cst_src_referral_cst_recno_ext,
          ind_first_name: this.wizard.Individual.cst_src_referral_member_first_name_ext,
          ind_last_name: this.wizard.Individual.cst_src_referral_member_last_name_ext,
        };

        ind_full_name_cp = this.Instructor.ind_full_name_cp = this.Instructor.ind_first_name + ' ' + this.Instructor.ind_last_name;
      } else if (this.wizard.Individual.cst_src_specify_other_ext) {
        ind_full_name_cp = this.Instructor = this.wizard.Individual.cst_src_specify_other_ext;
      }
    }

    this.group = new UntypedFormGroup({
      'InstructorName': this.InstructorName = new UntypedFormControl(ind_full_name_cp, [Validators.required]),
      'Instructor': new UntypedFormControl(this.Instructor, [])
    });

    if (this.parentGroup) {
      this.parentGroup.registerControl('Instructor Referral', this.group);
    }
  }

  public ngOnDestroy(): void {
    if (this.parentGroup) {
      this.parentGroup.removeControl('Instructor Referral');
    }
  }

  public InstructorOnSelect(e: TypeaheadMatch): void {
    this.group.get('Instructor').setValue(e.item);
    this.Instructor = e.item;
  }
}
